<script setup lang="ts">
withDefaults(
  defineProps<{
    text: string | number
    variant?: 'neutral' | 'accent' | 'soon' | 'count'
  }>(),
  { variant: 'neutral' },
)
</script>

<template>
  <span class="badge" :class="`badge-${variant}`">{{ text }}</span>
</template>

<style scoped>
.badge {
  display: inline-flex;
  align-items: center;
  height: 18px;
  padding: 0 6px;
  border-radius: var(--r-chip);
  font-size: var(--fs-xs);
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  line-height: 1;
}
.badge-neutral { background: var(--bg-2); color: var(--muted); }
.badge-accent  { background: var(--accent-soft); color: var(--accent-2); }
.badge-soon    { background: var(--accent-soft); color: var(--accent-2); }
.badge-count {
  background: var(--accent);
  color: white;
  text-transform: none;
  letter-spacing: 0;
  min-width: 18px;
  justify-content: center;
}
</style>
